import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-system', en)

export * from './src/pages/not-found-404'
export * from './src/pages/demo'
export * from './src/pages/force-update'
export * from './src/pages/refresh'
export * from './src/components'
